/**
 * useUI Hook - Thin wrapper for App.js integration
 * 
 * Provides access to UI store and actions with a legacy-compatible interface.
 */

import { useCallback } from 'react';
import { useUIStore } from '../stores/uiStore';

export function useUI() {
    const store = useUIStore();

    // Stable actions
    const setUpgradeModal = store.setUpgradeModal;
    const isUpgradeModalOpen = store.isUpgradeModalOpen;

    const setIsUpgradeModalOpen = useCallback((isOpen: boolean) => {
        setUpgradeModal(isOpen);
    }, [setUpgradeModal]);

    const setUpgradeFeature = useCallback((feature: string) => {
        setUpgradeModal(isUpgradeModalOpen, feature);
    }, [setUpgradeModal, isUpgradeModalOpen]);

    return {
        // State
        view: store.view,
        isDrawerOpen: store.isDrawerOpen,
        isDarkMode: store.isDarkMode,
        showToast: store.showToast,
        fadingId: store.fadingId,
        isUpgradeModalOpen,
        upgradeFeature: store.upgradeFeature,
        actionLoading: store.actionLoading,
        fadingInventoryItem: store.fadingInventoryItem,

        // Actions
        setView: store.setView,
        setIsDrawerOpen: store.setDrawerOpen,
        toggleDrawer: store.toggleDrawer,
        setIsDarkMode: store.setDarkMode,
        toggleDarkMode: store.toggleDarkMode,
        triggerToast: store.triggerToast,
        setFadingId: store.setFadingId,
        setIsUpgradeModalOpen,
        setUpgradeFeature,
        setActionLoading: store.setActionLoading,
        setFadingInventoryItem: store.setFadingInventoryItem,
    };
}
